import { render, staticRenderFns } from "./Milestone-Invoice.vue?vue&type=template&id=ca28b984"
import script from "./Milestone-Invoice.vue?vue&type=script&lang=js"
export * from "./Milestone-Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports